/* eslint-disable */

import {
  FETCH_PRODUCT_DATA_FAILURE,
  FETCH_PRODUCT_DATA_SUCCESS,
  FETCH_PRODUCT_DETAILS_DATA_FAILURE,
  FETCH_PRODUCT_DETAILS_DATA_SUCCESS,
} from './actionCreator';

const initialState = {
  products: [],
  product: {},
  error: null,
};

const productReducer = (state = initialState, action) => {
  const { type, data, err } = action;

  switch (type) {
    case FETCH_PRODUCT_DATA_SUCCESS:
      return {
        ...state,
        packages: action.payload,
        error: null,
      };
    case FETCH_PRODUCT_DATA_FAILURE:
      return {
        ...state,
        error: err,
      };
    case FETCH_PRODUCT_DETAILS_DATA_SUCCESS:
      return {
        ...state,
        product: action.payload,
        error: null,
      };
    case FETCH_PRODUCT_DETAILS_DATA_FAILURE:
      return {
        ...state,
        error: err,
      };
    default:
      return state;
  }
};

export { productReducer };

